import axios from 'axios';
import { serialize } from 'object-to-formdata';
import { getToken } from './helpers';
import { apiUrl } from './constants/const';

const API = {
  resolveQueryParams: params => {
    return Object.keys(params)
      .map(k =>
        Array.isArray(params[k])
          ? params[k].map(a => `${encodeURIComponent(k)}[]=${encodeURIComponent(a)}`).join('&')
          : `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`
      )
      .join('&');
  },

  // Create FormData object for file uploads and mixed data
  createFormData: function(data) {
    const formData = new FormData();

    // Helper function to append data recursively
    const appendData = (key, value) => {
      if (value === null || value === undefined) {
        return;
      }

      if (value instanceof File) {
        // Handle File objects
        formData.append(key, value);
      } else if (value && typeof value === 'object' && value.file instanceof File) {
        // Handle file objects with additional properties (like avatar: {file: File, url: string})
        formData.append(key, value.file);
      } else if (Array.isArray(value)) {
        // Handle arrays
        value.forEach((item, index) => {
          appendData(`${key}[${index}]`, item);
        });
      } else if (typeof value === 'object') {
        // Handle nested objects
        Object.keys(value).forEach(subKey => {
          if (subKey !== 'file' && subKey !== 'url') { // Skip file and url properties for file objects
            appendData(`${key}[${subKey}]`, value[subKey]);
          }
        });
      } else {
        // Handle primitive values
        formData.append(key, value.toString());
      }
    };

    // Process all data
    Object.keys(data).forEach(key => {
      appendData(key, data[key]);
    });

    return formData;
  },
  get: function (route, queryParams) {
    /*let finalRoute = route;
    if (queryParams) {
      finalRoute += `?${this.resolveQueryParams(queryParams)}`;
    }*/
    return this.fetch(route, 'GET', queryParams);
    //return this.fetch(finalRoute, 'GET');
  },
  
  post: function (route, body, isFormData = false, config = {}) {
    return this.fetch(route, 'POST', body, isFormData, config);
  },

  put: function ( route, body, ) {
    return this.fetch(route, 'PUT', body);
  },

  delete: function (route, body) {
    return this.fetch(route, 'DELETE', body);
  },
  fetch: async function (route, method, body = {}, isFormData = false, config = {}) {
    let token = getToken() || '';
    return await axios(route, {
      method,
      headers: {
        'x-locale': localStorage.getItem('current_language') || 'en',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': isFormData ? undefined : 'application/json',
        Authorization: 'Bearer ' + token,
        'Access-Control-Allow-Origin': '*',
      },
      baseURL: apiUrl,
      data: isFormData ? this.createFormData(body) : JSON.stringify(body),
      params: method.toUpperCase() === 'GET' ? body : {},
      ...config,
    })
      .then(response => {
        let data = response.data ? response.data : '';
        try {
          data = JSON.parse(response.data);
        } catch (e) { }
        return data;
      })
      .catch(error => {
        let errorResp = { errors: ['Server error'] };
        if (error.response && error.response.data) {
          try {
            errorResp = JSON.parse(error.response.data);
          } catch (e) {
            errorResp = error.response.data;
          }
        }
        if (error?.response?.status === 401) {
          //logout?
          window.location.href = '/login';
        }
        throw errorResp;
      });
  },
};

export default API;
